import React, { useEffect, useState } from "react";
import UserMenuHeader from "../Authentication/UserMenuHeader";
import SignInMenuHeader from "../Authentication/SignInMenuHeader";
import { UserAuth } from "../Context";
import HeaderMenu from "./HeaderMenu";
import { Link, useLocation, useParams } from "react-router-dom";
import "./style.css";
import useSearchInputStore from "../StatesStore/SearchInputStore";
import UserMenuHeader4 from "../Authentication/UserMenuHeader4";
import useUrlState from "../StatesStore/CurrentURL";
import useChatOpen from "../StatesStore/ChatOpen";
import { getCategoryDisplayName } from "../lib/getCategoryName";
import ChatFilter from "../Chat/ChatFilter";

function Header() {
  const { user } = UserAuth();
  const location = useLocation();
  const { url } = useUrlState();
  const { setIsChatOpen } = useChatOpen();
  const [allProductsHeaderTopValue, setAllProductsHeaderTopValue] = useState(
    "All Products"
  );
  const [
    allProductsHeaderBottomValue,
    setAllProductsHeaderBottomValue,
  ] = useState("Ready to wear");
  const [category, setCategory] = useState("");
  // Input state is used to store user input
  // const [input, setInput] = useState("");
  const {
    searchInput,
    setSearchInput,
    resetSearchInput,
  } = useSearchInputStore();
  // Handle outside click
  const handleOutsideClick = () => {
    const main = document.getElementById("main");
    // const navbarCollapsible = document.getElementById("navbarCollapse");
    const brand = document.getElementById("brandsCollapse");
    // const category = document.getElementById("categoryCollapse");
    const menCategory = document.getElementById("menCollapse");
    const womenCategory = document.getElementById("womenCollapse");
    resetSearchInput();
    function fun() {
      if (main && main.classList.contains("show")) {
        main.setAttribute("data-bs-toggle", "collapse");
        main.setAttribute("data-bs-target", "#navbarCollapse");
      } else {
        main.removeAttribute("data-bs-target", "#navbarCollapse");
        main.removeAttribute("data-bs-toggle", "collapse");
      }
      if (user && brand && brand.classList.contains("show")) {
        brand.classList.remove("show");
      }
      // if (category.classList.contains("show")) {
      //   category.classList.remove("show");
      // }
      if (user && menCategory && menCategory.classList.contains("show")) {
        menCategory.classList.remove("show");
      }
      if (user && womenCategory && womenCategory.classList.contains("show")) {
        womenCategory.classList.remove("show");
      }
    }
    setTimeout(fun, 400);
  };

  useEffect(() => {
    if (location.pathname.includes("/AllProducts")) {
      setCategory(location.pathname.split("/")[2]);
      let subCategory = location.pathname.split("/")[3];
      let subSubCategory = location.pathname.split("/")[4];
      const mappedSubSubCategory = getCategoryDisplayName(subSubCategory);
      setAllProductsHeaderTopValue(mappedSubSubCategory);
      const mappedSubCategory = getCategoryDisplayName(subCategory);
      setAllProductsHeaderBottomValue(mappedSubCategory);
      console.log("mappedSubCategory", mappedSubCategory);
    }
    return () => {};
  }, [location.pathname]);

  useEffect(() => {
    const main = document.getElementById("main");
    main.addEventListener("click", handleOutsideClick);
    // const brand = document.getElementById("brandsCollapse");
    // const category = document.getElementById("categoryCollapse");
    // brand.addEventListener("click", handleOutsideClick);
    // category.addEventListener("click", handleOutsideClick);
    return () => {
      main.removeEventListener("click", handleOutsideClick);
      // brand.removeEventListener("click", handleOutsideClick);
      // category.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  // Handle search
  // const handleSearch = (e) => {
  //   e.preventDefault();
  //   if (searchInput.length > 2) {
  //     window.location.href = `#/search/${searchInput}`;
  //   }
  // };
  const handleLogoClick = () => {
    setSearchInput(""); // Reset searchInput state to empty
  };

  useEffect(() => {
    let lastScrollY = window.scrollY;
    const navbar = document.querySelector(".mobile-navbar-wrapper");

    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY) {
        navbar.classList.add("hide-navbar");
      } else if (currentScrollY < lastScrollY || window.scrollY === 0) {
        navbar.classList.remove("hide-navbar");
      }

      lastScrollY = currentScrollY;
    };
    if (location.pathname.includes("/ProductDetails")) {
      window.addEventListener("scroll", handleScroll);
    }
    return () => {
      window.removeEventListener("scroll", handleScroll);
      navbar.classList.remove("hide-navbar");
    };
  }, [location]);
  return (
    <>
      <div
        className="mobile-navbar-wrapper d-flex align-items-center justify-content-between bg-white"
        style={{ padding: "8px 6px", height: "48px", gap: "10px" }}
      >
        <style jsx>
          {`
            .headerText {
              color: var(--bs-heading-color, inherit);
            }
            .mobile-navbar-wrapper {
              position: fixed;
              top: 0;
              left: 0;
              width: 100%;
              z-index: 1050;
              transition: transform 0.3s ease-in-out;
            }

            .mobile-navbar-wrapper.hide-navbar {
              transform: translateY(-100%);
            }
          `}
        </style>
        {/* Logo START */}
        <div className="d-flex align-items-center gap-1">
          {location.pathname.includes("/chat") ? (
            <div
              className="text-body text-center fs-icon"
              onClick={() => {
                window.history.back();
                setIsChatOpen(false);
              }}
            >
              <div className="d-flex align-items-center">
                <i className="fa-solid fa-arrow-left fs-5 me-2"></i>
                <div className="headerText">Chats</div>
              </div>
            </div>
          ) : location.pathname.includes("/AllProducts") ? (
            <div
              className="text-body text-center fs-icon"
              onClick={() => window.history.back()}
            >
              <div className="d-flex align-items-center ">
                <div className="fa-solid fa-arrow-left fs-5 me-2"></div>
                <div className="d-flex flex-column align-items-start">
                  <div
                    style={{
                      maxWidth: "145px",
                      fontSize: "1rem",
                      lineHeight: "1.3",
                    }}
                    className="text-truncate headerText"
                  >
                    {allProductsHeaderTopValue}
                  </div>
                  <div
                    style={{
                      maxWidth: "145px",
                      fontSize: "0.75rem",
                    }}
                    className="text-truncate headerText"
                  >
                    {allProductsHeaderBottomValue}
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <>
              {user && (
                <div
                  type="button"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasProfileDrawer"
                  aria-controls="offcanvasProfileDrawer"
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4 6H19M4 11.5H19M4 17H19"
                      stroke="#676A79"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
              )}
              <Link to="/" onClick={handleLogoClick}>
                <div
                  style={{
                    fontFamily: "Nunito Sans",
                    fontWeight: "600",
                    fontSize: "24px",
                    lineHeight: "100%",
                    letterSpacing: "0%",
                    textAlign: "center",
                    fontStyle: "italic",
                    color: "#676A79",
                  }}
                >
                  lookflock
                </div>
              </Link>
            </>
          )}
        </div>
        {/* Logo END */}
        <div
          className={`d-flex align-items-center w-100 justify-content-end`}
          style={{ gap: user ? "12px" : "0.25rem" }}
        >
          {user ? <UserMenuHeader4 /> : <SignInMenuHeader />}
        </div>
      </div>
      {location.pathname.includes("/chat") && <ChatFilter />}
    </>
  );
}

export default Header;
